import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { NgbDateStruct, NgbInputDatepicker } from "@ng-bootstrap/ng-bootstrap";
import { DestroyableMixin } from "apps-module/app/shared-library/mixins/destroyable.mixin";
import { shortKey } from "apps-module/app/shared-library/utils/common.utils";
import { NumericUtils } from "apps-module/app/shared-library/utils/numeric.utils";
import { EmptyInstance } from "core-library/mixins/empty-instance";
import { takeUntil } from "rxjs";

@Component({
    selector: "[pcg-ng-date-picker]",
    templateUrl: "./date-picker.component.html",
    host: {
        "class": "pcg-form-group"
    }
})
export class DatePickerComponent extends DestroyableMixin(EmptyInstance) implements OnInit {
    @ViewChild("picker", { read: NgbInputDatepicker, static: false })
    private _ngbDatePickerElementRef: NgbInputDatepicker;

    @Input()
    public label: string = null;

    @Input()
    public disabled: boolean = false;

    @Input("control")
    public set controlSetter(originalControl: FormControl<string>) {
        this.originalControl = originalControl;
        this.control.setValue(this.parseValue(originalControl.value), { emitEvent: false });
    }

    public control = new FormControl<NgbDateStruct>(null);
    public originalControl: FormControl<string> = null;

    @Output()
    public onSubmit = new EventEmitter();

    public id: string = null;
    public isCalendarOpened: boolean = false;

    public ngOnInit(): void {
        this.id = shortKey();

        this.originalControl.valueChanges.pipe(
            takeUntil(this.onDestroy)
        ).subscribe((value: string) => {
            this.control.setValue(this.parseValue(value), { emitEvent: false });
        });

        this.control.valueChanges.pipe(
            takeUntil(this.onDestroy)
        ).subscribe((value: NgbDateStruct) => {
            if (value) {
                this.originalControl.setValue(`${value.year}-${value.month.toString().padStart(2, "0")}-${value.day.toString().padStart(2, "0")}`, { emitEvent: false });
            } else {
                this.originalControl.setValue("", { emitEvent: false });
            }
            this.onSubmit.emit();
        });
    }

    public toggleCalendarPopup(): void {
        if (this.disabled) {
            return;
        }

        this._ngbDatePickerElementRef.toggle();
    }

    // NOTE: workaround for keyboard navigation
    public toggleCalendarPopup_2(): void {
        if (this.disabled) {
            return;
        }

        if (this.isCalendarOpened) {
            this._ngbDatePickerElementRef.close();
        } else {
            this._ngbDatePickerElementRef.open();
        }

        this.isCalendarOpened = !this.isCalendarOpened;
    }

    public clear(picker: NgbInputDatepicker): void {
        this.control.setValue(null);
        picker.close();
    }
    private parseValue(value: string): NgbDateStruct | null {
        if (value) {
            const dateParts = value.split("-");
            const dateValue = {
                year: NumericUtils.parse(dateParts[0], null),
                month: NumericUtils.parse(dateParts[1], null),
                day: NumericUtils.parse(dateParts[2], null)
            } as NgbDateStruct;
            return dateValue;
        } else {
            return null;
        }
    }
}
